//todo direct access to contact, suc-purchase, about
//todo fix m_amount param
//secret key: j60EVKfA9LP8MR7Q
//id: 1761981075


/*
const http = require("http");
const { MCrypt } = require("mcrypt");
const { createHash } = require("crypto");

const rijndael256ecb = (data, secret) => {
  const cipher = new MCrypt("rijndael-256", "ecb");
  cipher.validateKeySize(false);
  cipher.open(secret);
  return cipher.encrypt(data).toString("base64");
};

const sha256 = (data) => {
  return createHash("sha256").update(data).digest("hex");
};

const base64encode = (data) => {
  return Buffer.from(data).toString("base64");
};

const md5 = (data) => {
  return createHash("md5").update(data).digest("hex");
};

const basicProps = {
  shopId: "1",
  secretKey: "secret",
  callbackUrls: {
    success_url: "mega-mramor.com/suc-purchase",
    fail_url: "mega-mramor.com/fail",
    status_url: "mega-mramor.com/status"
  }
};

function generatePaymentPageUrl(orderId, price) {
  const { shopId, secretKey, callbackUrls } = basicProps;
  const description = base64encode(`Order ID: ${orderId}`);
  const amount = price.split(" ")[0];
  const currency = price.split(" ")[1];
  const hash = [shopId, orderId, amount, currency, description];
  const key = md5(secretKey + orderId);
  const urls = JSON.stringify(callbackUrls);
  const params = encodeURIComponent(rijndael256ecb(urls, key));
  hash.push(params, secretKey);
  const sign = sha256(hash.join(":")).toUpperCase();

  const queryParams = {
    m_shop: shopId,
    m_orderid: orderId,
    m_amount: amount,
    m_curr: currency,
    m_desc: description,
    m_sign: sign,
    m_params: params,
    m_process: "send"
  };

  return queryParams;

  //return `https://payeer.com/merchant/?${stringify(queryParams)}`;
}

function genMultiplePayment(r) {
  return JSON.stringify(
    r.map(([orderId, price]) => generatePaymentPageUrl(orderId, price))
  );
}

//create a server object:
http
  .createServer(function (req, res) {
    const r = [
      ["d1d3d919-7d45-47e2-9b9a-7b2d0fd4b530", "520 USD"],
      ["066bfdc5-5f05-48ef-b16a-047d76b963c5", "190 USD"],
      ["454f0efa-7fdf-45f0-b80d-d8f050bc5fa5", "350 USD"],
      ["dbcf7c16-035a-414b-8f65-6c3c2baf1062", "475 USD"],
      ["282c92d9-28fc-4d44-ba11-9878bd7b59cf", "345 USD"],
      ["736502a0-5cbc-45b7-aca5-ae10c8208325", "530 USD"],
      ["330613bc-2771-4aab-8cd9-86151489694c", "280 USD"],
      ["1d0fe21d-8011-4069-9fee-e6a1389aaac5", "120 USD"],
      ["ece8888b-2a1c-4d70-aaef-6b3fd17a005d", "130 USD"]
    ];

    res.write(genMultiplePayment(r)); //write a response to the client
    res.end(); //end the response
  })
  .listen(8090); //the server object listens on port 8080

*/

const arrGen = [{"m_shop":"1761981075","m_orderid":"d1d3d919-7d45-47e2-9b9a-7b2d0fd4b530","m_amount":"520.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IGQxZDNkOTE5LTdkNDUtNDdlMi05YjlhLTdiMmQwZmQ0YjUzMA==","m_sign":"B062DF7D0F6175040F4BC9E50C4962FA2E24CEF7E5F41B8F90727B7687B34F1D","m_params":"mZq3Dqjy26%2Flr%2FxxdeTCHYOsQC%2B2N03gvBaDOXiPcpw1z22Ruqn5GoXDjeD%2BvsqfTJtWsc3uyFFHIUnUr5ZVQ%2BQuCGtRR3Vi2bGV7XBuXhBM1OFUqRUN4g7L2S7jFcB3EXg2QpVv5PonIK4fKfEwk3%2FUcA7Xz%2FszT9MMb3Cmd%2BY%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"066bfdc5-5f05-48ef-b16a-047d76b963c5","m_amount":"190.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IDA2NmJmZGM1LTVmMDUtNDhlZi1iMTZhLTA0N2Q3NmI5NjNjNQ==","m_sign":"729FCCE73B6D79C52C48E2522250D0DFB37CCE498B0C5C581091DC1CEBD7304C","m_params":"9MxdnpOB5xbObYCQQc%2F%2BM1dRKMM4P5l4%2FZm7fDEJF%2Bf1ufany3Gs76u0RGFXLS0F9%2FqCazZwM9cIdOYZf%2Bx%2F1c%2FBn7kZ5Xrs0LLBFOR17gaF5ygx%2FZXpi5eVNVshcrpwx%2BoNilkalgto1Rme3%2FZruvcvzx7gGVvEHyEwAdfjTJs%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"454f0efa-7fdf-45f0-b80d-d8f050bc5fa5","m_amount":"350.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IDQ1NGYwZWZhLTdmZGYtNDVmMC1iODBkLWQ4ZjA1MGJjNWZhNQ==","m_sign":"EDCCA471812F366978F3FEEAF75D04B21D39EE92822754B8A13FC82DC194EBE2","m_params":"6Rm%2FCSUcV%2FHe6tcZ7ceefCjw0ow8bhdMRiRwFgVt12oGllSUOxRm9yphgto8G0WCbe3fS7xy0keSwIRqkL3nm%2B%2FpC6yib2PVAg%2FrHcC9mydgfE5bo7txO9xLLIc06GwDSORRnrfRHbs2G3rej7YCjh%2FDev5%2ByUBk5NSJaG2Bbmc%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"dbcf7c16-035a-414b-8f65-6c3c2baf1062","m_amount":"475.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IGRiY2Y3YzE2LTAzNWEtNDE0Yi04ZjY1LTZjM2MyYmFmMTA2Mg==","m_sign":"7E0A53744C6A172CD3216F98F80933F57AF280FAB73A4F279413BCD3C0EA2424","m_params":"FB5QdIjEDbmv50T55TG2Ys1e2jM0kl35NaSYvfsij6i4hS0lnnlqFs%2BrABRcDwbAxTqYhQ9LQy7%2Fieyjd06gHhLu6sv8pMCgOZMmUUpmWuCZncmWeTw6qBiT7Ajxj%2F1vdeqNLwiU6D%2BDjoSrReQ%2B8rm9gqa%2FBPqY9Jsn9zD0NMM%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"282c92d9-28fc-4d44-ba11-9878bd7b59cf","m_amount":"345.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IDI4MmM5MmQ5LTI4ZmMtNGQ0NC1iYTExLTk4NzhiZDdiNTljZg==","m_sign":"5396BE08A6AC0CF028334CDF73153358F3A33E1AB4FE46217FE7E60ED7200B11","m_params":"ns%2FPA6zirdG%2FtCkP5v5XWeK6w92FzGaWB6lCbOAI%2B%2FMskoZZf2k9tzFHg9ZkwkgUyzyZgrGKbsRKNLKZoU2W4ZmoJPP%2F8S5rJiaDyFtP5Mw772yL7AII9zmVZIczF2wcx6F4%2BDvADhGBiJVPWtbebUpKP%2BrcB4FhGNX%2BpCqUhDs%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"736502a0-5cbc-45b7-aca5-ae10c8208325","m_amount":"530.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IDczNjUwMmEwLTVjYmMtNDViNy1hY2E1LWFlMTBjODIwODMyNQ==","m_sign":"06E0AE0FE790740168DE2F9EB7B16F9A839BF8D2327C3C5F9638FC56F15A56FA","m_params":"Jhz1voj5574Ca0cHWqDmCUXkXCzEWzBcL8koERYSQt%2FoJOYmtFvMryfkFtAcJ0K8SuNE3iXv4xE%2FxvwzxWp08%2B9JkHxYDquy%2B9B%2Bcemq80Df9lrUIL8Xjpz9wzH2DPE%2BEM0FLLupA2g4ytm6PI3uqSUAGZEpf%2FTDJNEI0YIu8W4%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"330613bc-2771-4aab-8cd9-86151489694c","m_amount":"280.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IDMzMDYxM2JjLTI3NzEtNGFhYi04Y2Q5LTg2MTUxNDg5Njk0Yw==","m_sign":"808835BA53A8D2894F0BA5F3C791D8C23715C30DD33BB5E85C5EBCD2574690E2","m_params":"YJ%2B1BH929zpUyd8kG3hZZIML6rBEmJA5IoEd9e1icokZrqVL4gbEk1360bkX1fQJnHRBkqq8y9BHfD6WfVM%2FY35yQEe4hWIILUWhyodEav3aMBsWq%2BkXxEbgjgQwrXmwfxbnLWhM1YivK9NCzMbziN5jSttEe0hBQe1McuTnVWM%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"1d0fe21d-8011-4069-9fee-e6a1389aaac5","m_amount":"120.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IDFkMGZlMjFkLTgwMTEtNDA2OS05ZmVlLWU2YTEzODlhYWFjNQ==","m_sign":"8ACC44D98D4C0BE805211E399E1A02A6493709169570058ADCB4F1DADA65B433","m_params":"qdq3QpIKh6HEacSsXOQ2cBSV5Xn1G6F3H2gzwHhptR6tjCZDIVUqHF9ivP4qrU7gzIT7kHWUxxQsFu122GfYUCfJV7M4KCf1hrhxIi7Nw8Jkw%2B3LJuxXVsre%2B4%2FvPTtX4hUL0rA%2F57yuf5Ageb1w1Za0jz63rLW2%2FK9s%2BUWmxvM%3D","m_process":"send"},{"m_shop":"1761981075","m_orderid":"ece8888b-2a1c-4d70-aaef-6b3fd17a005d","m_amount":"130.00","m_curr":"USD","m_desc":"T3JkZXIgSUQ6IGVjZTg4ODhiLTJhMWMtNGQ3MC1hYWVmLTZiM2ZkMTdhMDA1ZA==","m_sign":"12D4ECAFF6004E70899D886E63A50AAE32D8FAB17DDAAF01980704A62CF61E00","m_params":"bSzpVJ5MsuXHh1CPQAknILHQwuXvDjr4PQ6%2BSNvokGGFlfxyDIEdIoDqkd3EQFH7jG2oFo72XnL%2BrnKO9itZSAMcRrLDV5eH6ou54Sa2DlsMArW2TtXVocmjm20zvERw64CKXuv1x0ERasEKrtaV2dDGUh%2FrZ9FeOj9cJECRpQE%3D","m_process":"send"}];

const pregenerated = {
	"d1d3d919-7d45-47e2-9b9a-7b2d0fd4b530": arrGen[0],
	"066bfdc5-5f05-48ef-b16a-047d76b963c5": arrGen[1],
	"454f0efa-7fdf-45f0-b80d-d8f050bc5fa5": arrGen[2],
	"dbcf7c16-035a-414b-8f65-6c3c2baf1062": arrGen[3],
	"282c92d9-28fc-4d44-ba11-9878bd7b59cf": arrGen[4],
	"736502a0-5cbc-45b7-aca5-ae10c8208325": arrGen[5],
	"330613bc-2771-4aab-8cd9-86151489694c": arrGen[6],
	"1d0fe21d-8011-4069-9fee-e6a1389aaac5": arrGen[7],
	"ece8888b-2a1c-4d70-aaef-6b3fd17a005d": arrGen[8],
}

function BuyButton({payeerProps, productId, cost}){
	//const {m_shop, m_orderid, m_amount, m_curr, m_desc, sign} = payeerProps;
	const {m_shop, m_orderid, m_amount, m_curr, m_desc, m_sign} = pregenerated[productId];
	
	return (
	  <form method="post" action="https://payeer.com/merchant/">
		<input type="hidden" name="m_shop" value="{m_shop}"/>
		<input type="hidden" name="m_orderid" value="{m_orderid}"/>
		<input type="hidden" name="m_amount" value="{m_amount}"/>
		<input type="hidden" name="m_curr" value="{m_curr}"/>
		<input type="hidden" name="m_desc" value="{m_desc}"/>
		<input type="hidden" name="m_sign" value="{m_sign}"/>
			{
			/*
			<input type="hidden" name="form[ps]" value="2609">
			<input type="hidden" name="form[curr[2609]]" value="USD">
			*/ 
			/*
			<input type="hidden" name="m_params" value="<?=$m_params?>">
			<input type="hidden" name="m_cipher_method" value="AES-256-CBC">
			*/ 
			}
			<button type="submit" name="m_process" class="fa fa-shopping-cart"></button>
			
			{/*<i class="fa fa-shopping-cart">
		<input type="submit" name="m_process" value="" />
			</i>*/}
	  </form>
	);
}

function Home() {
	/*let m_shop = '';
	let m_orderid = '1';
	let m_amount = 'qwe';//number_format(100, 2, '.', '');
	let m_curr = 'USD';
	let m_desc = 'qwe';//base64_encode('Test');
	let m_key = 'Ваш секретный ключ';
	
	const arHash = [m_shop, m_orderid, m_amount, m_curr, m_desc];
	
	const sign = 'qwe';*/
	
	const payeerProps={};//{ m_shop, m_orderid, m_amount, m_curr, m_desc, sign };
	console.log('test');
	
    return (
      <div className="home-main">
            <div class="main-banner" id="top">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="left-content">
                                <div class="thumb">
                                    <div class="inner-content">
                                        <h4>We Are Mega</h4>
                                        <span>Awesome and unique style for you.</span>
                                        <span>Buy NFT and be sure that noone else in the world wearing this!</span>
                                        <div class="main-border-button">
                                            <a href="#men">Purchase Now!</a>
                                        </div>
                                    </div>
                                    <img src="assets/images/left-banner-image.jpg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="right-content">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="right-first-image">
                                            <div class="thumb">
                                                <div class="inner-content">
                                                    <h4>Women</h4>
                                                    <span>Best Style For Women</span>
                                                </div>
                                                <div class="hover-content">
                                                    <div class="inner">
                                                        <h4>Women</h4>
                                                        <p>Best designers created this style for you</p>
                                                        <div class="main-border-button">
                                                            <a href="#women">Discover More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <img src="assets/images/baner-right-image-01.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="right-first-image">
                                            <div class="thumb">
                                                <div class="inner-content">
                                                    <h4>Men</h4>
                                                    <span>Best Style For Men</span>
                                                </div>
                                                <div class="hover-content">
                                                    <div class="inner">
                                                        <h4>Men</h4>
                                                        <p>Our styles will perfectly represent your manhood</p>
                                                        <div class="main-border-button">
                                                            <a href="#men">Discover More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <img src="assets/images/baner-right-image-02.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="right-first-image">
                                            <div class="thumb">
                                                <div class="inner-content">
                                                    <h4>Kids</h4>
                                                    <span>Best Style For Kids</span>
                                                </div>
                                                <div class="hover-content">
                                                    <div class="inner">
                                                        <h4>Kids</h4>
                                                        <p>This style will emphasize your kids uniqueness</p>
                                                        <div class="main-border-button">
                                                            <a href="#kids">Discover More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <img src="assets/images/baner-right-image-03.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="right-first-image">
                                            <div class="thumb">
                                                <div class="inner-content">
                                                    <h4>Accessories</h4>
                                                    <span>Best Trend Accessories</span>
                                                </div>
                                                <div class="hover-content">
                                                    <div class="inner">
                                                        <h4>Accessories</h4>
                                                        <p>Express yourself in every detail</p>
                                                        <div class="main-border-button">
                                                            <a href="#explore">Discover More</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <img src="assets/images/baner-right-image-04.jpg" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <section class="section" id="men">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="section-heading">
                                <h2>Men's Best</h2>
                                <span>Details to details is what makes Mega different from the other themes.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="men-item-carousel">
                                <div class="owl-men-item owl-carousel">
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
													<BuyButton
														payeerProps={payeerProps}
														productId="d1d3d919-7d45-47e2-9b9a-7b2d0fd4b530" 
														cost="520"
													/>
													{/*<a href="single-product"><i class="fa fa-shopping-cart"></i></a>*/}
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/men-01.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Classic Spring</h4>
                                            <span>$520.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
													<BuyButton
														payeerProps={payeerProps}
														productId="066bfdc5-5f05-48ef-b16a-047d76b963c5" 
														cost="190"
													/></li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/men-02.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Air Force 1 X</h4>
                                            <span>$190.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="454f0efa-7fdf-45f0-b80d-d8f050bc5fa5" 
															cost="350"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/men-03.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Love Nana ‘20</h4>
                                            <span>$350.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
          
            <section class="section" id="women">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="section-heading">
                                <h2>Women's Best</h2>
                                <span>Details to details is what makes Mega different from the other themes.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="women-item-carousel">
                                <div class="owl-women-item owl-carousel">
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="dbcf7c16-035a-414b-8f65-6c3c2baf1062" 
															cost="475"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/women-01.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Strict Freedom</h4>
                                            <span>$475.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="282c92d9-28fc-4d44-ba11-9878bd7b59cf" 
															cost="345"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/women-02.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Classic Dress</h4>
                                            <span>$345.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="736502a0-5cbc-45b7-aca5-ae10c8208325" 
															cost="530"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/women-03.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Spring Collection</h4>
                                            <span>$530.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
          
            <section class="section" id="kids">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="section-heading">
                                <h2>Kid's Latest</h2>
                                <span>Details to details is what makes Mega different from the other themes.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="kid-item-carousel">
                                <div class="owl-kid-item owl-carousel">
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="330613bc-2771-4aab-8cd9-86151489694c" 
															cost="280"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/kid-01.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>School Collection</h4>
                                            <span>$280.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="1d0fe21d-8011-4069-9fee-e6a1389aaac5" 
															cost="120"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/kid-02.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Summer Cap</h4>
                                            <span>$120.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="item">
                                        <div class="thumb">
                                            <div class="hover-content">
                                                <ul>
												{/*
                                                    <li><a href="single-product"><i class="fa fa-eye"></i></a></li>
                                                    <li><a href="single-product"><i class="fa fa-star"></i></a></li>
												*/}
                                                    <li>
														<BuyButton
															payeerProps={payeerProps}
															productId="ece8888b-2a1c-4d70-aaef-6b3fd17a005d" 
															cost="130"
														/>
													</li>
                                                </ul>
                                            </div>
                                            <img src="assets/images/kid-03.jpg" alt="" />
                                        </div>
                                        <div class="down-content">
                                            <h4>Classic Kid</h4>
                                            <span>$130.00</span>
                                            <ul class="stars">
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                                <li><i class="fa fa-star"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
         
            <section class="section" id="explore">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="left-content">
                                <h2>Explore Our Accessories</h2>
                                <span>Accessories provide interest to your outfit. Without them, you run the risk of getting bored with your wardrobe, and your outfits looking boring, because they're always the same.</span>
                                <div class="quote">
                                    <i class="fa fa-quote-left"></i><p>Accessories extend the life of your clothes and familiar ensembles</p>
                                </div>
                                <p>Right now we are working on our new collection. It will be published next month</p>
                                {/*<div class="main-border-button">
                                    <a href="products.html">Discover More</a>
                                </div>*/}
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="right-content">
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="leather">
                                            <h4>Leather Bags</h4>
                                            <span>Latest Collection</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="first-image">
                                            <img src="assets/images/explore-image-01.jpg" alt="" />
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="second-image">
                                            <img src="assets/images/explore-image-02.jpg" alt="" />
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="types">
                                            <h4>Different Types</h4>
                                            <span>For every taste</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
			{/*
            <section class="section" id="social">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="section-heading">
                                <h2>Social Media</h2>
                                <span>Details to details is what makes Therichpost different from the other themes.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row images">
                        <div class="col-2">
                            <div class="thumb">
                                <div class="icon">
                                    <a href="http://instagram.com">
                                        <h6>Fashion</h6>
                                        <i class="fa fa-instagram"></i>
                                    </a>
                                </div>
                                <img src="assets/images/instagram-01.jpg" alt="" />
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="thumb">
                                <div class="icon">
                                    <a href="http://instagram.com">
                                        <h6>New</h6>
                                        <i class="fa fa-instagram"></i>
                                    </a>
                                </div>
                                <img src="assets/images/instagram-02.jpg" alt="" />
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="thumb">
                                <div class="icon">
                                    <a href="http://instagram.com">
                                        <h6>Brand</h6>
                                        <i class="fa fa-instagram"></i>
                                    </a>
                                </div>
                                <img src="assets/images/instagram-03.jpg" alt="" />
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="thumb">
                                <div class="icon">
                                    <a href="http://instagram.com">
                                        <h6>Makeup</h6>
                                        <i class="fa fa-instagram"></i>
                                    </a>
                                </div>
                                <img src="assets/images/instagram-04.jpg" alt="" />
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="thumb">
                                <div class="icon">
                                    <a href="http://instagram.com">
                                        <h6>Leather</h6>
                                        <i class="fa fa-instagram"></i>
                                    </a>
                                </div>
                                <img src="assets/images/instagram-05.jpg" alt="" />
                            </div>
                        </div>
                        <div class="col-2">
                            <div class="thumb">
                                <div class="icon">
                                    <a href="http://instagram.com">
                                        <h6>Bag</h6>
                                        <i class="fa fa-instagram"></i>
                                    </a>
                                </div>
                                <img src="assets/images/instagram-06.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
			*/}
        
            <div class="subscribe">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8">
                            <div class="section-heading">
                                <h2>By Subscribing To Our Newsletter You Can Get 10% Off</h2>
                                <span>Details to details is what makes Mega different from the other themes.</span>
                            </div>
                            <form id="subscribe" action="javascript:setTimeout(() => alert('Thank you for subscription!'), 1000)">
                                <div class="row">
                                <div class="col-lg-5">
                                    <fieldset>
                                    <input name="name" type="text" id="name" placeholder="Your Name" required="" />
                                    </fieldset>
                                </div>
                                <div class="col-lg-5">
                                    <fieldset>
                                    <input name="email" type="text" id="email" pattern="[^ @]*@[^ @]*" placeholder="Your Email Address" required="" />
                                    </fieldset>
                                </div>
                                <div class="col-lg-2">
                                    <fieldset>
                                    <button type="submit" id="form-submit" class="main-dark-button"><i class="fa fa-paper-plane"></i></button>
                                    </fieldset>
                                </div>
                                </div>
                            </form>
                        </div>
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-12">
                                    <ul>
                                        <li>Store Brand:<br /><span>Mega Mramor</span></li>
                                        <li>Phone:<br /><span>+7-747-109-48-63</span></li>
                                        <li>Email:<br /><span>info@mega-mramor.com</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Home;